export default "__VITE_ASSET__CEPgupgo__"